/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";
import * as Integrations from "@sentry/integrations";

import i18n from "./config/i18n";
import * as Sentry from "@sentry/browser";
if (process.env.VUE_APP_LOAD_SENTRY == "true") {
  Sentry.init({
    dsn: "https://1ac066f479734eceb953407d09e3322a@sentry.io/1849069",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    release: process.env.VUE_APP_VERSION
  });
}
// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";

import VueGtag from "vue-gtag";
Vue.use(VueHammer);
if (typeof process.env.VUE_APP_GOOGLE_ANALYTICS != "undefined") {
  Vue.use(
    VueGtag,
    {
      config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS }
    },
    router
  );
}

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import Logging from "./services/Logging";
import './registerServiceWorker'
// Feather font icon
require("./assets/css/iconfont.css");

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    /**
     * Shows the error
     * @param {string} message Shows a message to  user
     * @param {boolean} hardError If the whole page needs to crash or only a part
     */
    showError(message, hardError, err) {
      if (err != null) {
        Logging.logException(err);
      }
      if (hardError) {
        let fullPath = this.$route.fullPath;

        this.$store.commit("setErrorMessage", { message, fullPath });
        this.$router.push("/error");
      } else {
        this.$vs.notify({
          title: "Foutmelding",
          text: `${
            message != null ? message : this.$t("Error.title")
          } <br/><br/>Klik hier om opnieuw te proberen`,
          color: "danger",
          position: "bottom-center",
          time: 8000,
          iconPack: "feather",
          icon: "icon-alert-triangle",
          click: () => {
            this.$router.go();
          }
        });
      }
    }
  }
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
